import { DocumentInterface } from "../../interfaces/documents/DocumentInterface";

export const mapDocumentsResponse = (response: {
    data: Array<{ name: string; extension: string; url: string }>;
}): DocumentInterface[] =>
    response.data.map((document) => ({
        fileName: document.name,
        fileType: document.extension,
        fileUrl: document.url,
    }));
